import React, { useEffect, useRef, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import FormTextField from "../../components/formFields/FormTextField";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import {
  createFacility,
  getAllFacilities,
  getFacilityByID,
  updateFacility,
} from "./services/facility.service";
import { clearFacilityDetails } from "./facilitySlice";
import { RxCross1 } from "react-icons/rx";
import { closed } from "../../components/drawer/drawerSlice";
import IconButton from "../../components/common/IconButton";

const CreateFacility: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  // const location = useLocation();
  // const FacilityID = location.state?.FacilityID;
  const FacilityID = useAppSelector((state) => state.drawer.data);
  const FacilityDetail = useAppSelector(
    (state) => state.facility.FacilityDetail,
  );
  const loading = useAppSelector((state) => state.facility.formLoading);

  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [FacilityDetail]);

  useEffect(() => {
    if (FacilityID) {
      dispatch(getFacilityByID(FacilityID));
    }
    return () => {
      dispatch(clearFacilityDetails());
    };
  }, [FacilityID]);

  const handleSubmit = async (values: any) => {
    const formData = {
      Title: values.Title ?? "",
      Description: values.Description ?? "",
      IsActive: values.IsActive === 1,
    };
    // const ImageData = new FormData();
    // const Image =
    //   values?.Image && typeof values?.Image !== "string"
    //     ? getFile(values?.Image)
    //     : "";

    try {
      if (FacilityID) {
        const editPayload = {
          ...formData,
          ID: FacilityID,
        };

        const response = await dispatch(updateFacility(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());

          // if (values?.Image && typeof values?.Image !== "string") {
          //   ImageData.append("Image", Image);
          //   ImageData.append("ID", FacilityID);
          //   await dispatch(FacilityImageUpload(ImageData));
          // }
          dispatch(getAllFacilities());
          dispatch(clearFacilityDetails());
        }
      } else {
        const response = await dispatch(createFacility(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          // if (
          //   values?.Image &&
          //   typeof values?.Image !== "string" &&
          //   response?.payload?.Data?.ID
          // ) {
          //   ImageData.append("Image", Image);

          //   ImageData.append("ID", response?.payload?.Data?.ID);
          //   await dispatch(FacilityImageUpload(ImageData));
          // }
          dispatch(getAllFacilities());
          dispatch(clearFacilityDetails());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <div>
        <Form
          onSubmit={handleSubmit}
          key={formKey}
          initialValues={FacilityDetail}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement>
              <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
                <GridLayoutItem className="master-drawer-header">
                  <Typography.h4 className="m-0">
                    {FacilityID ? "Update Facility" : "Add Facility"}
                  </Typography.h4>

                  <IconButton
                    type="button"
                    fillMode={"flat"}
                    themeColor={"dark"}
                    style={{ marginRight: 4 }}
                    onClick={() => dispatch(closed())}
                    icon={RxCross1}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="Title"
                    label="Title"
                    placeholder="Title"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                {/* <GridLayoutItem>
                  <Field
                    name="Description"
                    label="Description"
                    component={FormRichTextField}
                    style={{ height: 120 }}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    justifyContent="start"
                    name={`Image`}
                    label="Image"
                    type="file"
                    alternateName="Image"
                    component={FormImageUpload}
                  />
                </GridLayoutItem> */}
                <GridLayoutItem>
                  <Field
                    name={`IsActive`}
                    label="Status"
                    placeholder="i.e. Active"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={STATUSARRAY?.map((status: any) => {
                      return {
                        value: status?.value,
                        label: status?.label,
                      };
                    })}
                  />
                </GridLayoutItem>

                <GridLayoutItem
                  style={{
                    marginTop: "20px",
                    textAlign: "end",
                  }}
                >
                  <div>
                    <ButtonWithLoading
                      label={FacilityID ? "Update" : "Save"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />
                    <Button
                      type="button"
                      fillMode={"outline"}
                      themeColor={"primary"}
                      style={{ marginLeft: 10 }}
                      onClick={() => dispatch(closed())}
                    >
                      Cancel
                    </Button>
                  </div>
                </GridLayoutItem>
              </GridLayout>
            </FormElement>
          )}
        />
      </div>
    </>
  );
};

export default CreateFacility;
